<template>
    <v-sheet elevation="2" class="pa-4 mb-12" rounded>
        <v-row>
            <v-col cols="12" v-text="label" />
            <v-col cols="12">
                <slot name="top" />
            </v-col>
        </v-row>
        <v-row v-if="!hideFields">
            <v-col cols="12">
                <textarea-field
                    :rows="3"
                    label="Street"
                    required
                    :rules="[requiredRule('Street')]"
                    v-model="model.street"
                />
            </v-col>

            <v-col cols="12" md="6">
                <text-field
                    label="City"
                    required
                    :rules="[requiredRule('City')]"
                    v-model="model.city"
                />
            </v-col>

            <v-col cols="12" md="6">
                <text-field label="County" v-model="model.county" />
            </v-col>

            <v-col cols="12" md="6">
                <text-field
                    label="Postcode"
                    required
                    :rules="[requiredRule('Postcode')]"
                    v-model="model.postcode"
                />
            </v-col>

            <v-col cols="12" md="6">
                <country-picker v-model="model.country_id" />
            </v-col>
        </v-row>
    </v-sheet>
</template>

<script>
import TextField from "./TextField";
import TextareaField from "./TextareaField";
import ValidationRules from "../../Mixins/ValidationRules";
import CountryPicker from "./CountryPicker";
import VModel from "../../Mixins/VModel";

export default {
    name: "AddressForm",
    components: { CountryPicker, TextareaField, TextField },

    mixins: [ValidationRules, VModel],

    props: {
        label: {
            required: true,
            type: String,
        },
        hideFields: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped></style>
